<template>
    <div style="background:#FAFAFA;" class="policeLato">
        <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
        <section class="mt-5" v-if="isMobile()">
            <div class="paralax-cover-image_mobile has-background-dim_mobile">
                <p class="paralax-cover-image-text_mobile">
                <div class="content_home" style="z-index: 1!important;margin-top: 10%">
                    <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">Simulation</span></h1>
                    <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>{{ $t('devis.devis_voyage.header_title[2]') }}</span></h1>
                </div>
                </p>
            </div>
        </section>
        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div>
            <div class="container" style="background:#FAFAFA">
                <div class="container justify-content-center row text-center mb-5 mt-5">
                  <p class="mb-3"  style="font-weight: 300;color: #ffa409;font-family: Open Sans, sans-serif;font-size:25px!important;margin-top: 30px;">
                  <span class="font-weight-bold">{{ $t('devis.devis_auto.simulation_title') }}</span>
                  <!-- {{ $t('devis.simulation_title') }} <span class="font-weight-bold">{{ $t('devis.devis_auto.title[3]') }}</span> -->
                  </p> <br>
              </div>
                <br>

                <div class="row" style="background:#FAFAFA" v-if="isMobile()">
                    <div class="col-md-10" style="background:#FAFAFA">
                        <div class="form" style="background:#FAFAFA">
                            <div class="wizard-navigation">
                            <div class="wizard-progress-with-circle">
                                <div class="wizard-progress-bar" style="background-color: rgb(231, 76, 60); color: rgb(231, 76, 60); width: 4.54545%;"></div>
                            </div>
                            <div class="progress-bar-group">
                                <div class="progress-bar-custom" id="testup"></div>
                            </div>
                            <ul role="tablist" class="wizard-nav wizard-nav-pills">
                                <li class="step" id="firstStep">
                                    <div class="step-title text-center mr-4">{{ $t('devis.devis_voyage.stepper_title[0]') }}</div>
                                </li>
                                <!-- <li class="step" id="secondStep">
                                    <div class="step-title text-center mr-4">{{ $t('devis.devis_voyage.stepper_title[1]') }}</div>
                                </li> -->
                              <li class="step" id="thirtStep">
                                <div class="step-title text-center mr-4">{{ $t('devis.devis_voyage.stepper_title[2]') }}</div>
                              </li>
                            </ul>
                        </div>
                        </div>
                    </div>
                </div>
                <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE     =============== -->
                <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
                <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
                <!-- ========================================================================================= -->
                <div v-responsive.sm.xs>
                    <div class="mt-5" style="background:#FAFAFA">
                    <div class="row" style="background:#FAFAFA">

                        <div class="col-md-10" style="background:#FAFAFA">
                            <div class="form" style="background:#FAFAFA">
                                <div class="page" v-show="step === 1">
                                    <div class="wizard-tab-content">
                                        <div role="tabpanel" id="Step1_mobile" aria-labelledby="step-Step1_mobile" class="wizard-tab-container">
                                            <div>
                                                <div class="fields">
                                                    <div class="field-title">{{ $t('devis.devis_voyage.titre_stepr_1') }} & {{$t('devis.devis_voyage.titre_stepr_2')}}&nbsp;:</div>
                                                    <div class="field-group field-default mb-4 mb-sm-0" >
                                                        <label for="Stepper3_mobile" class="field-label">{{$t('devis.devis_voyage.paysVoyage.Headline_2')}}</label>
                                                        <!-- <select id="Stepper3_mobile" name="Step1_mobile" class="field-select" v-model="destination">
                                                            <option v-for="item in countries" :key="item" :value="item.PAYS" @change="Stepper1Validator">{{item.PAYS}}</option>
                                                        </select> -->
                                                        <div class="custom-select-container">
                                                                <div class="custom-select" :class="{active: isDropdownOpen}" @click="toggleDropdown">
                                                                    <input 
                                                                        type="text"  
                                                                        v-model="searchCountry"
                                                                        :placeholder="destinationCountry ? destinationCountry.PAYS : 'Sélectionner le pays de destination'"
                                                                        class="select-input"
                                                                        @click.stop="openDropdown"
                                                                        @focus="openDropdown"
                                                                        @input="filterCountries"
                                                                        readonly
                                                                    />

                                                                </div>
                                                                <div class="options-container" v-show="isDropdownOpen">
                                                                    <div class="search-option">
                                                                        <input 
                                                                            type="text"  
                                                                            v-model="searchCountry"
                                                                            placeholder="Rechercher un pays..."
                                                                            class="search-input-in-options"
                                                                            @click.stop
                                                                            @input="filterCountries"
                                                                            ref="searchInput"
                                                                        />
                                                                    </div>
                                                                    <div 
                                                                        class="option" 
                                                                        v-for="(item, index) in filteredCountries" 
                                                                        :key="index"
                                                                        @click="selectCountry(item)"
                                                                    >
                                                                        {{ item.PAYS }}
                                                                    </div>
                                                                    <div class="no-results" v-if="filteredCountries.length === 0 && searchCountry">
                                                                        Aucun pays trouvé
                                                                    </div>
                                                                </div>
                                                            </div>
                                                    </div>
                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                      <label for="Stepper25_mobile" class="field-label">
                                                        {{$t('devis.devis_voyage.dateVoyage.Headline_1')}}
                                                        <!---->
                                                      </label>
                                                      <div class="input-group value-loan">
                                                        <date-picker :disabled-date="disabledAfterToday" class="field-input mb-1 mt-1" :editable="false" placeholder="Cliquer ici" id="Stepper25_mobile" @change="yearsDiffDateDepart()" v-model="dateDepart" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                      </div>
                                                    </div>
                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                      <label for="Stepper25_mobile" class="field-label">
                                                        {{$t('devis.devis_voyage.dateVoyage.Headline_2')}}
                                                        <!---->
                                                      </label>
                                                      <div class="input-group value-loan">
                                                        <date-picker :disabled-date="disabledBeforeToday" class="field-input mb-1 mt-1" :editable="false" placeholder="Cliquer ici" id="Stepper25_mobile" @change="yearsDiffDateRetour()" v-model="dateArrivee" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                      </div>
                                                    </div>

                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                    <label for="Stepper25_1_mobile" class="field-label">
                                                                        {{$t('devis.devis_voyage.dateVoyage.Headline_4')}}
                                                                        <!---->
                                                                    </label>
                                                                    <div class="input-group value-loan">
                                                                        <date-picker :disabled-date="disabledAfterTodayBirth" class="field-input mb-1 mt-1" :editable="false" placeholder="Cliquer ici" id="Stepper25_1_mobile" @change="PassengerAgeCalculation()" v-model="dateNaissance" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                    </div>
                                                                </div>

                                                                <div class="field-group field-default">
                                                            <label for="Stepper3" class="field-label">{{$t('devis.devis_voyage.modalite')}}</label>
                                                            <select id="Stepper3" name="Step1" class="field-select" v-model="remboursable">
                                                                <option value="remboursable">Remboursable</option>
                                                                <option value="Non_remboursable">Non remboursable</option>
                                                            </select>
                                                        </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="wizard-card-footer clearfix">
                                        <div class="wizard-footer-left">
                                        </div>
                                        <div class="wizard-footer-right">
                                            <button @click="Stepper1Validator()" type="button" class="wizard-btn">
                                                {{$t('devis.devis_voyage.bouton_suivant')}}
                                        </button>
                                        </div>
                                        <!---->
                                    </div>

                                </div>

                                 <div class="page review_page" v-show="step === 2">
                                        <div class="wizard-tab-content">
                                            <div role="tabpanel" id="Step10_mobile" aria-hidden="true" aria-labelledby="step-Step10_mobile" class="wizard-tab-container">
                                                <div>
                                                    <div class="justify-content-center row field-title" style="color:#ffa409">
                                                        {{$t('devis.devis_voyage.HeadLineSteper_6')}}
                                                    </div>
                                                    <div class="field-title">
                                                        {{$t('devis.devis_voyage.titreTableauRecapVoyage')}}&nbsp;:
                                                    </div>
                                                    <div class="fields" v-for="(vyg,index) in tableauVoyage" :key="index">
                                                        <div class="field-group row align-items-center">
                                                            <div class="col-lg-4"><label for="Stepper29_mobile" class="field-label">{{$t('devis.devis_voyage.entetTableeauRec[0]')}}</label></div>
                                                            <div class="col-lg-8 field-default">
                                                                <input disabled type="text" id="Stepper29_mobile" name="Step10_mobile" :value="vyg.pays_domicile" class="field-input pac-target-input">
                                                                <div class="field-error">
                                                                    <!---->
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="field-group row align-items-center">
                                                            <div class="col-lg-4"><label for="Stepper30_mobile" class="field-label">{{$t('devis.devis_voyage.entetTableeauRec[1]')}}</label></div>
                                                            <div class="col-lg-8 field-default">
                                                                <input disabled type="text" id="Stepper30_mobile" name="Step10_mobile" :value="vyg.destination.PAYS" class="field-input pac-target-input">
                                                                <div class="field-error">
                                                                    <!---->
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="field-group row align-items-center">
                                                            <div class="col-lg-4"><label for="Stepper31_mobile" class="field-label">{{$t('devis.devis_voyage.entetTableeauRec[2]')}}</label></div>
                                                            <div class="col-lg-8 field-default">
                                                                <input disabled type="tel" id="Stepper31_mobile" name="Step10_mobile" :value="vyg.dateDepart" class="field-input">
                                                                <div class="field-error">
                                                                    <!---->
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="field-group row align-items-center">
                                                            <div class="col-lg-4"><label for="Stepper32_mobile" class="field-label">{{$t('devis.devis_voyage.entetTableeauRec[3]')}}}</label></div>
                                                            <div class="col-lg-8 field-default">
                                                                <input disabled type="text" id="Stepper32_mobile" name="Step10_mobile" :value="vyg.dateArrivee" class="field-input">
                                                                <div class="field-error">
                                                                    <!---->
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="field-group row align-items-center">
                                                            <div class="col-lg-4"><label for="Stepper33_mobile" class="field-label">{{$t('devis.devis_voyage.entetTableeauRec[4]')}}</label></div>
                                                            <div class="col-lg-8 field-default">
                                                                <input disabled type="text" id="Stepper33_mobile" name="Step10_mobile" :value="vyg.nbpassager" class="field-input">
                                                                <div class="field-error">
                                                                    <!---->
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="field-group row align-items-center">
                                                            <div class="col-lg-4"><label for="Stepper37_mobile" class="field-label">{{$t('devis.devis_voyage.entetTableeauRec[5]')}}</label></div>
                                                            <div class="col-lg-8 field-default">
                                                                <input style="margin-bottom:4px" v-for="(passager,index) in listPassager" :key="index" disabled  type="text" id="Stepper37_mobile" name="Step10_mobile" :value="passager.adulte_enfant + ' ' + passager.age_passager + ' an(s)'" class="field-input">
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="fields">
                                                        <div class="field-title">
                                                            {{$t('devis.devis_voyage.entetChoixAssureurMobile')}}&nbsp;:
                                                        </div>
                                                        <!-- Grid moderne pour les assureurs -->
                              <div class="insurers-grid">
                                <!-- Bouton "Tous" -->
                                <div class="insurer-card all-insurers" :class="{ 'selected': selectAll }">
                                  <input v-model="selectAll" type="checkbox" id="tous_mobile" class="insurer-input">
                                  <label for="tous_mobile" class="insurer-label">
                                    <div class="insurer-icon">
                                      <img src="../../assets/img/icones/all.png" alt="Tous les assureurs" class="insurer-logo">
                                    </div>
                                    <div class="insurer-info">
                                      <h4 class="insurer-name">{{ $t('devis.devis_auto.bouton_tous') }}</h4>
                                      <span class="insurer-badge">Tous</span>
                                    </div>
                                    <div class="selection-indicator">
                                      <i class="fas fa-check"></i>
                                    </div>
                                  </label>
                                </div>

                                <!-- Cartes des assureurs -->
                                <div 
                                  class="insurer-card" 
                                  v-for="assure in listeAssureurs" 
                                  :key="assure._id"
                                  :class="{ 'selected': assureurs.includes(assure.societe) }"
                                >
                                  <input 
                                    v-model="assureurs" 
                                    type="checkbox" 
                                    :value="assure.societe" 
                                    :id="assure.societe"
                                    class="insurer-input"
                                  >
                                  <label :for="assure.societe" class="insurer-label">
                                    <div class="insurer-icon">
                                      <img :src="assure.logo" :alt="assure.societe" class="insurer-logo">
                                    </div>
                                    <div class="insurer-info">
                                      <h4 class="insurer-name">{{ assure.societe }}</h4>
                                      <span class="insurer-badge">Assureur</span>
                                    </div>
                                    <div class="selection-indicator">
                                      <i class="fas fa-check"></i>
                                    </div>
                                  </label>
                                </div>
                              </div>

                              <!-- Résumé de la sélection -->
                              <div class="selection-summary" v-if="assureurs.length > 0">
                                <div class="summary-content">
                                  <i class="fas fa-info-circle"></i>
                                  <span>{{ assureurs.length }} {{ $t('devis.devis_auto.assureur_label') }}{{ assureurs.length > 1 ? 's' : '' }} {{ $t('devis.devis_auto.selectionne_label') }}{{ assureurs.length > 1 ? 's' : '' }}</span>
                                </div>
                              </div>
                                                        <!-- <div class="field-group row field-bank">
                                                             <div class="btn-choice col-sm-3 col-4">
                                                                <input v-model="selectAll" type="checkbox" id="tous_mobile" class="field-input">
                                                                <label for="tous_mobile" class="field-label" label="Tous">
                                                                    <img src="../../assets/img/icones/all.png" alt="Tous_mobile" height="60" width="60">
                                                                    <p class="field-title" style="margin-top:-12px;margin-bottom:-10px;color:#ffa409">{{$t('devis.devis_voyage.tous')}}</p>
                                                                </label>
                                                            </div>
                                                            <div class="btn-choice col-sm-3 col-4" v-for="assure in listeAssureurs" :key="assure._id">
                                                                <input v-model="assureurs" type="checkbox" :value="assure.societe" :id="assure.societe" class="field-input">
                                                                <label :for="assure.societe" class="field-label" :label="assure.societe">
                                                                    <img :src="assure.logo" :alt="assure.societe" height="50">
                                                                    <p class="field-title" style="margin-top:-3px;margin-bottom:-10px">{{assure.societe.substr(0, 6)}}</p>
                                                                </label>
                                                            </div>
                                                        </div> -->
                                                    </div>
                                                </div>
                                            </div>

                                           

                                           
                                            </div>

                                        <div class="wizard-card-footer clearfix">
                                            <div class="wizard-footer-left">
                                                <button @click="BacktoSecondStep()" type="button" class="wizard-btn">
                                                    <span class="fas fa-arrow-left"></span>
                                                    {{$t('devis.devis_voyage.bouton_retour')}}
                                                </button>
                                            </div>
                                            <div class="wizard-footer-right">
                                                <button :disabled="disabledButtonValidate" @click="saveVoyage()" type="button" class="wizard-btn">
                                                    {{$t('devis.devis_voyage.bouton_valider')}}
                                                </button>
                                            </div>
                                            <!---->
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>

         <div v-if="dialogLoading && isMobile" class="loading-state">
            <div class="loading"></div>
            <span class="ml-3 loading-text">Simulation en cours, Veuillez patienter !</span>
        </div>

        <!-- <v-dialog v-model="dialogLoading" persistent width="700" v-if="isMobile()">
            <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FFA409">
                <div class="wizard-tab-content" style="background:#FFA409">
                <div role="tabpanel" id="infosPerso" aria-hidden="true" aria-labelledby="step-infosPerso" class="wizard-tab-container">
                    <div>
                    <div class="loan-group loan-group-0" style="background:#FFA409">
                        <div class="fields text-center" style="background:#FFA409">
                            <span class="field-title font-weight-bold" style="color:#fff">Simulation en cours, Veuillez patienter !</span>
                        </div>
                        <div class="fields text-center" style="background:#FFA409">
                            <v-progress-circular size="50" color="white" class="mr-2" indeterminate></v-progress-circular>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </v-card-text>
            </v-card>
        </v-dialog> -->

        <!-- INCLUSION DU POPUP DE LOGIN AU CAS OU LE USER VOULANT FAIRE UNE VALIDATION N'EST PAS CONNECTE -->
        <login-form :visible="showLoginForm" @close="showLoginForm=false"></login-form>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    import Api from '../../services/Api'
    import store from '../../store/store'
    import LoginForm from './../auth/Login'
    import configVoyage from '../../common/configVoyage.json'
    import PushInDataLayer from '../../services/TagManager'
    import { countryController } from '../../packages/country/country.controller';


    export default {
        name: 'SimulationDevisVoyage',
        components: {
            LoginForm
        },
        data() {
            return {
                countryOfOrigin: "Sénégal",
            destinationCountry: null,
            departureDate: null,
            arrivalDate: null,
            listCountry: [],
            searchCountry: "",
            isDropdownOpen: false,





            dialogLoading : false,
            disabledButtonValidate : false,
            expand: false,
            ChangeAgePassager: false,
            disable_rn: false,
            remboursable: null,
            Non_remboursable: null,
            datePickerPassengerBirth: false,
            dateNaissance: null,
            voyageDialogToBlok: false,
            disabled: false,
            switch1: false,
            selected: [],
            showLoginForm: false,
            step: 1,
            age: '',
            ageDepart: '',
            ageArrivee : '',
            nbpassager: 1,
            countries: [],
            countriesSn: 'Sénégal',
            tableauVoyage: [],
            garanties: [],
            i18nFrVoyage: null,
            autres_garanties: [],
            adulte_enfant: null,
            destination: '',
            pays_domicile: '',
            VoyageToUpdate: null,
            listeAssureurs: [],
            popupAddGaranties: false,
            dateSouscription: new Date().toISOString().substr(0, 10),
            dateEffet: null, //new Date().toISOString().substr(0, 10),
            dateEcheance: null, //new Date().toISOString().substr(0, 10),
            dateDepart: null,
            dateArrivee: null,
            datePickerArrivee: false,
            datePickerDepart: false,
            datePickerEffet: false,
            duree_contrat: '',
            NombrePassagers: ['1'],
            listPassager: [],
            proprietaire: '',
            assureurs: [],
            ToastTabSucess: {
                theme: 'toasted-primary',
                position: 'top-center',
                duration: 5000,
                fitToScreen: true,
                type: 'success',
                className: 'custom-success-class'
            }, // Customized options for success toast
            ToastTabError: {
                theme: 'toasted-primary',
                position: 'top-center',
                duration: 5000,
                fitToScreen: true,
                type: 'error'
            }, // Customized options for error toast
            branche: 'Voyage',
            zone_garantie: '',
            showPeriode: false,
            notif: false,



                neant: 'N.A',
                date: new Date().toISOString().substr(0, 10),
            }
        },
        methods: {
               openDropdown() {
        this.isDropdownOpen = true;
        this.$nextTick(() => {
            if (this.$refs.searchInput) {
                this.$refs.searchInput.focus();
            }
        });
    },
     // Fermer le dropdown quand on clique ailleurs sur la page
    closeDropdown(event) {
        if (!event.target.closest('.custom-select-container')) {
            this.isDropdownOpen = false;
        }
    },
    toggleDropdown() {
        if (this.isDropdownOpen) {
            this.isDropdownOpen = false;
        } else {
            this.openDropdown();
        }
    },
    selectCountry(country) {
        this.destinationCountry = country;
        this.searchCountry = country.PAYS; // Afficher le pays sélectionné
        this.isDropdownOpen = false;
    },
    filterCountries() {
        // Le filtrage se fait automatiquement via la computed property
    },
            checkToken() {
                Api().get('user/check/token')
                .then((resultat) => {
                // verifie si le token exist
                if (!resultat.data.ok) {
                    store.state.isUserLoggedIn = false;
                    store.dispatch("setUser", {});
                    store.dispatch("setToken", {});
                    this.showLoginForm = true
                    }
                }).catch((err) => {
                    // verifie  si le token est expiré
                    if(err.response.data.ok === false){
                    store.state.isUserLoggedIn = false;
                    store.dispatch("setUser", {});
                    store.dispatch("setToken", {});
                    this.showLoginForm = true
                    }
                });
            },
            disabledBeforeToday(date) {
              const today = dayjs(this.dateDepart).add(+1, 'day')
              return date < today;
            },
            disabledAfterToday(date) {
              const today = dayjs(new Date()).add(-1, 'day')
              return date < today;
            },
            disabledAfterTodayBirth(date) {
              const today = dayjs(new Date()).add(-1, 'day')
              return date > today;
            },

            BacktoSecondStep(){
                this.step = 1
                this.tableauVoyage = []
                this.listPassager = []
                this.dateNaissance = null

            },

            yearsDiffDateDepart() {
                const date1 = dayjs(this.dateDepart);
                const date2 = dayjs(new Date().toISOString().substr(0, 10));
                let daydiff = date2.diff(date1, 'days');
                this.ageDepart = daydiff;

                if (this.ageDepart > 0) {
                    this.ageDepart = null;
                    this.annee_mois = '';
                    this.$toasted.show('Erreur, date postérieure à la date actuelle! ', this.ToastTabError)
                    this.dateDepart = null

                } else if (this.ageDepart <= 29) {
                    this.an = this.annee_mois = 'jour(s)'

                } else if (this.ageDepart >= 30, this.ageDepart <= 360) {
                    let year = Math.floor(this.ageDepart / 30);
                    this.ageDepart = year;
                    this.an = this.annee_mois = 'mois'

                } else if (this.ageDepart >= 360) {
                    let year = Math.floor(this.age / 360);
                    this.ageDepart = year;
                    this.annee = year;
                    this.year = this.ageDepart;
                    this.an = this.annee_mois = 'an(s)'
                }

            },
            yearsDiffDateRetour() {
                const date1 = dayjs(this.dateArrivee);
                const date2 = dayjs(this.dateDepart);
                let daydiff = date2.diff(date1, 'days');

                this.ageArrivee = daydiff;

                if (this.ageArrivee > 0) {
                    this.ageArrivee = null;
                    this.annee_mois = '';
                    this.$toasted.show('Erreur, date postérieure à la date de départ! ', this.ToastTabError)
                    this.dateArrivee = null

                }else {
                    this.daysDiff()
                }

            },
             prev() {
                this.step--;
            },
            next() {
                this.step++;
            },

       
        daysDiff() {
            const date1 = dayjs(this.dateDepart);
            const date2 = dayjs(this.dateArrivee);
            let daydiff = date2.diff(date1, 'day');
            this.duree_contrat = daydiff + 1;
            this.dateDiff()
        },

        /* On affiche le popup pour ajouter des garanties supplementaires a un vehicule(item) */
        AddGaranties(vyg) {
            this.VoyageToUpdate = vyg;
            this.popupAddGaranties = true
        },

        /*==========VALIDATION ELEMENTS SETEPPER 1===========*/
        Stepper1Validator() {
                if (this.destinationCountry) {
                    if (typeof this.pays_domicile == 'string') {

                        if (this.pays_domicile == this.destinationCountry.PAYS) {
                            this.$toasted.show('Pays de destination doit être différent du pays de depart', this.ToastTabError)
                        } else {
                          if (this.dateDepart) {
                            if (this.dateArrivee) {
                                    if(this.dateNaissance) {
                                        if(this.remboursable) {
                                            if(dayjs(this.dateArrivee).diff(this.dateDepart,"day")>=1){
                                                this.step = 2
                                                this.CreateListPassager()
                                                this.RecapUserData()
                                                document.getElementById("testup").classList.add('widthFirst');
                                                document.getElementById("firstStep").classList.add('checked');
                                            }else{
                                                this.$toasted.show("Plage de date non conforme !", this.ToastTabError)
                                            }
                                        } else {
                                            this.$toasted.show('Modalités de remboursement obligatoire', this.ToastTabError)
                                        }
                                    } else {
                                        this.$toasted.show('Date de naissance obligatoire', this.ToastTabError)
                                    }
                                } else {
                                this.$toasted.show("Date de retour obligatoire !", this.ToastTabError)
                                }
                          } else {
                            this.$toasted.show("Date de départ obligatoire !", this.ToastTabError)
                          }
                        }

                    } else if (typeof this.pays_domicile == 'object') {
                        this.destinat = true;
                        if (this.pays_domicile.PAYS == this.destinationCountry.PAYS) {
                            this.$toasted.show('Pays de destination doit être différent du pays de depart', this.ToastTabError)
                        } else {
                          if (this.dateDepart) {
                            if (this.dateArrivee) {
                                if(this.dateNaissance) {
                                    if(this.remboursable) {
                                        if(dayjs(this.dateArrivee).diff(this.dateDepart,"day")>=1){
                                            this.step = 2
                                            this.RecapUserData();
                                            this.CreateListPassager()
                                            document.getElementById("testup").classList.add('widthFirst');
                                            document.getElementById("firstStep").classList.add('checked');
                                        }else{
                                            this.$toasted.show("Plage de date non conforme !", this.ToastTabError)
                                        }
                                    } else {
                                            this.$toasted.show('Modalités de remboursement obligatoire', this.ToastTabError)
                                    }
                                } else {
                                    this.$toasted.show('Date de naissance obligatoire', this.ToastTabError)
                                }
                            } else {
                              this.$toasted.show("Date de retour obligatoire !", this.ToastTabError)
                            }
                          } else {
                            this.$toasted.show("Date de départ obligatoire !", this.ToastTabError)
                          }
                        }

                    }

                } else {
                    this.$toasted.show('Pays de destination obligatoire', this.ToastTabError)
                }

        },

        /*=========Initialisation des donneespour affichage recap========*/
        RecapUserData: function () {
            const devisVoyage = {
                'pays_domicile': this.pays_domicile,
                'destination': this.destinationCountry,
                'nbpassager': this.nbpassager,
                'dateNaissance': this.dateNaissance,
                'garanties': this.garanties,
                'autres_garanties': this.autres_garanties,
                'dateDepart': this.dateDepart,
                'dateArrivee': this.dateArrivee,

            };
            this.tableauVoyage.push(devisVoyage)
        },
        PassedToNext() {
            this.RecapUserData();
            this.e1 = 5
        },

        dateDiff: function () {
            if (this.dateDepart === '' && this.duree_contrat === '') this.dateEcheance = '';
            let inter = dayjs(this.dateDepart).add((this.duree_contrat-1), 'day').format('YYYY-MM-DD');
            this.dateEcheance = dayjs(inter).format('YYYY-MM-DD')
            this.yearsDiffDateDepart()
        },

        isMobile: function () {
            if (screen.width <= 760) {
                return true
            } else {
                return false
            }
        },

        isDesktop: function () {
            if (screen.width > 760) {
                return true
            } else {
                return false
            }
        },

        /*====Recuperation de la liste des Pays depuis API====*/
        async getListePays () {
            // Api().get('pays')
            //     .then(response => {
            //         this.countries = response.data

            //     })
            //     .catch(err => {
            //         err
            //     })
            try {
                const country = await countryController
                this.listCountry = country.data
            } catch (error) {
                console.error("Error :", error)
            }
        },

        /*====Recuperation de la liste des Partners depuis API====*/
        getListePartenaire: function () {
            Api().get('partenaire/partners/voyage')
                .then(response => {
                    this.listeAssureurs = response.data.partenaires
                })
                .catch(err => {
                    err
                })
        },

        displayPeriode: function () {
            if (this.dateEffet && this.dateEcheance) {
                this.showPeriode = true
            }
        },

        /*====REMPLISAAGE DES PASSAGERS POUR DEVIS VOYAGE====*/
       CreateListPassager: function () {
                let Unpassager = {};

         if (this.nbpassager) {
             if (this.age < 18) {
               Unpassager.adulte_enfant = 'Enfant'
             } else if (this.age >= 18) {
               Unpassager.adulte_enfant = 'Adulte'
             }
             Unpassager.age_passager = this.age;
             Unpassager.dateNaissance = this.dateNaissance
             this.listPassager.push(Unpassager);
             this.age = null;

             if (this.listPassager.length === parseInt(this.nbpassager)) {
            //    this.PassedToNext()
            //    this.next()
               document.getElementById("testup").classList.add('widthFirst');
                document.getElementById("firstStep").classList.add('checked');
             }
             else {
               this.age = null;
               this.adulte_enfant = null
             }
         } else {
           this.$toasted.show("Veuillez saisir le nombre de passager!", this.ToastTabError)
         }



            },
            /*Passenger Age calculation based on passenger birthday*/
            PassengerAgeCalculation() {
                const date1 = dayjs(this.dateNaissance);
                const date2 = dayjs(new Date().toISOString().substr(0, 10));
                let daydiff = date2.diff(date1, 'days');
                this.age = daydiff;

                if (this.age < 0) {
                    this.age = null;
                    this.annee_mois = '';
                    this.$toasted.show('Erreur, date de naissance postérieure à la date actuelle! ', this.ToastTabError)
                    this.dateNaissance = null

                } else {
                     let TodayDate = new Date()
                    this.age = dayjs(TodayDate).diff(this.dateNaissance, 'year')

                    let PassengerObject = {
                        dateNaissance: this.dateNaissance,
                        age: this.age
                    }
                    localStorage.setItem('passenger-birthady-age', JSON.stringify(PassengerObject))
                }
            },

        /*===============ENVOI DES DATA A L'API ===================*/
        saveVoyage: function () {
            if (!store.state.isUserLoggedIn)
            {
                const val = {
                    position :'quote-creation',
                    event:'login_intent'
                }
                this.$loginPopupPosition.position='quote-creation'
                PushInDataLayer(val)
                this.showLoginForm = true
            } else
            {
                if (this.duree_contrat) {
                    if (this.dateDepart) {
                        if (this.assureurs.length > 0) {

                            if (this.remboursable) {
                                document.getElementById("thirtStep").classList.add('checked');
                                document.getElementById("testup").classList.add('widthThirt');
                                for (let index = 0; index < this.countries.length; index++) {
                                    if (this.countries[index].PAYS === this.destinationCountry) {
                                        this.destinationCountry = this.countries[index]
                                    }
                                }


                                const Voyage = {
                                    destination: this.destinationCountry,
                                    nbpassager: this.nbpassager,
                                    dateEffet: this.dateDepart,
                                    dateNaissance: this.dateNaissance,
                                    dateEcheance: this.dateEcheance,
                                    duree: this.duree_contrat,
                                    dateSouscription: dayjs(new Date()).format('YYYY-MM-DD'),
                                    mode_remboursement: this.remboursable,
                                    dateDepart: this.dateDepart,
                                    dateArrivee: this.dateArrivee,
                                    assureurs: this.assureurs,
                                    branche: this.branche,
                                    listPassager: this.listPassager,
                                    garanties: configVoyage.French.Garanties,
                                    plateforme:"Front",
                                    autres_garanties: this.autres_garanties
                                };

                                if (typeof this.pays_domicile == 'string') {
                                    Voyage.pays_domicile = this.pays_domicile
                                } else if (typeof this.pays_domicile == 'object') {
                                    Voyage.pays_domicile = this.pays_domicile.PAYS
                                }

                                this.disabledButtonValidate = true
                                this.dialogLoading = true;

                                Api().post('simulator/add', Voyage)
                                    .then(result => {

                                        let GtmVal = {
                                            branche : 'voyage',
                                            entry_point: localStorage.getItem('quoteCreationEntryPoint'),
                                            insurer_number: this.assureurs.length,
                                            event:'quote_creation'
                                        }
                                        PushInDataLayer(GtmVal)

                                        if (result.data.message)
                                        {
                                            this.notif = true;
                                            this.$store.dispatch('setDevis', result.data);
                                            this.dialogLoading = false, this.disabledButtonValidate = false, this.$router.push({
                                                name: 'listDevisSimulation'
                                                }) 
                                        }
                                    }).catch(error=>{
                                        console.error(error)
                                        const msg = (error.response && error.response.data && error.response.data.message) || 'La simulation a échoué. Veuillez réessayer.'
                                        this.$toasted.show(msg, this.ToastTabError)
                                        this.dialogLoading = false
                                        this.disabledButtonValidate = false
                                    })
                            } else {
                                this.$toasted.show("Modalités de remboursement obligatoire !", this.ToastTabError)
                            }

                        } else {
                            this.$toasted.show('Choisissez au moins un assureur !', this.ToastTabError)
                        }
                    } else {
                        this.$toasted.show("Date d'effet obligatoire ! ", this.ToastTabError)
                    }

                } else {
                    this.$toasted.show('Durée du voyage obligatoire !', this.ToastTabError)
                }

            }
        }

    },
    created() {
        this.i18nFrVoyage = configVoyage.French;
        this.GarantiesBase = configVoyage.French.Garanties;
        this.TyeSecuVol = configVoyage.French.Type_securite_vol;
        this.Autres_garanties = configVoyage.French.Autres_garanties
    },
    mounted: function () {
        window.scrollTo(0, 0);
        this.checkToken()
        this.displayPeriode();
        this.getListePartenaire();
        this.getListePays();
        this.pays_domicile = this.countriesSn;

    },
    computed: {
        filteredCountries() {
            if (!this.searchCountry) {
                return this.listCountry;
            }
            const searchTerm = this.searchCountry.toLowerCase();
            return this.listCountry.filter(country => 
                country.PAYS.toLowerCase().includes(searchTerm)
            );
        },
        selectAll: {
            get: function () {
                return this.listeAssureurs ? this.assureurs.length == this.listeAssureurs.length : false;
            },
            set: function (value) {
              const assureurs = [];

              if (value) {
                    this.listeAssureurs.forEach(function (assure) {
                        assureurs.push(assure.societe);
                    });
                }

                this.assureurs = assureurs;
            }
        }
    }

    }
</script>

<style lang="less" scoped>
    @import "../../assets/css/button.css";
    @import "../../assets/css/devis_css.css";



    .form {
        background-color: #fff;
        padding: 1.5rem;
    }

    .form .page {
        height: auto;
    }

    button.next {
        position: absolute;
        bottom: 0;
        right: 0;
        margin-right: 1.5rem;
        margin-bottom: 1rem;
    }

    button.previous {
        position: absolute;
        bottom: 0;
        left: 0;
        margin-left: 1.5rem;
        margin-bottom: 1rem;
    }


    button.edit {
        position: absolute;
        bottom: 0;
        right: 0;
    }

    h4 {
        color: #29323a;
        margin-bottom: 15px;
        font-weight: 600;
    }




    html {
        background-color: #1a1a1a;
        overflow: hidden;
    }
    .middle {
        width: auto;
        text-align: center;
        /* Made by */
    }
    .middle h1 {
        font-family: "Inter", sans-serif;
        color: #fff;
    }
    .middle input[type="radio"] {
        display: none;
    }
    .middle input[type="radio"]:checked + .box {
        background-color: rgba(255, 164, 9, 0.07);
        transition: all .33s ease;
        border: 2px solid #ffa409;
        color: #29323a;
    }
    .middle input[type="radio"]:checked + .box span {
        color: #29323a;
        transform: translateY(70px);
    }
    .middle input[type="radio"]:checked + .box span:before {
        transform: translateY(0px);
        opacity: 1;
    }
    .middle .box {
        width: 220px;
        height: 150px;
        border-radius: 12px;
        background-color: #fff;
        transition: all 250ms ease;
        will-change: transition;
        display: inline-block;
        text-align: center;
        cursor: pointer;
        position: relative;
        box-shadow: 0 4px 8px rgb(172 186 200 / 10%);
        font-size: 10px;
        border: 1px solid #d9dee3;
        font-family: Open Sans,sans-serif;
        font-weight: 900;
    }
    .middle .box:hover {
        background-color: rgba(255, 164, 9, 0.07);
        transition: all .33s ease;
        border: 2px solid #ffa409;
    }
    .middle .box:hover span {
        color: #29323a;
    }

    .middle .box:active {
        transform: translateY(10px);
    }
    .middle .box span {
        position: absolute;
        transform: translate(0, 60px);
        left: 0;
        right: 0;
        padding-top: 15%;
        transition: all 300ms ease;
        font-size: 1.5em;
        user-select: none;
        color: #29323a;
    }
    .middle .box span:before {
        font-size: 1.2em;
        font-family: FontAwesome;
        display: block;
        transform: translateY(-80px);
        opacity: 0;
        transition: all 300ms ease-in-out;
        font-weight: normal;
        color: #fff;
    }
    .middle p {
        color: #fff;
        font-family: "Inter", sans-serif;
        font-weight: 400;
    }
    .middle p a {
        text-decoration: underline;
        font-weight: bold;
        color: #fff;
    }
    .middle p span:after {
        content: "\f0e7";
        font-family: FontAwesome;
        color: yellow;
    }

    .widthFirst{
        background-color: var(--custom-color-primary)!important;
        height: 5px;
        border-radius: 5px;
        transition: width .33s ease;
        width:49.55556%;
    }
    .widthSecond{
        background-color: var(--custom-color-primary)!important;
        height: 5px;
        border-radius: 5px;
        transition: width .33s ease;
        width:0%;
    }
    .widthThirt{
        background-color: var(--custom-color-primary)!important;
        height: 5px;
        border-radius: 5px;
        transition: width .33s ease;
        width:100%;
    }
















    .paralax-cover-image {
        background-image: url('../../assets/img/assurance/voyage.jpg');
        position: relative;
        background-size: contain!important;
        background-position: 50%;
        min-height: 230px;
        width: 100%;
        margin: 0 0 0;
        display: flex;
        /*padding: 20px;*/
        align-items: center;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;

    }
    .paralax-cover-image p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
    }

    .paralax-cover-image .paralax-cover-image-text,
    .paralax-cover-image h2 {
        color: #fff;
        font-size: 2em;
        line-height: 1.25;
        z-index: 1;
        margin-bottom: 0;
        max-width: 610px;
        text-align: center;
        margin-left: 8.5%;
    }

    .paralax-cover-image.has-background-dim:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image {
        background-attachment: fixed;
        background-position: 50% 30px;
    }



    .paralax-cover-image_mobile {
        background-image: url('../../assets/img/assurance/voyage_mobile.jpg');
        position: relative;
        background-size: contain;
        background-position: 50%;
        min-height: 150px;
        width: 100%;
        margin: 0 0 0;
        display: flex;
        //padding: 20px;
        align-items: center;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;

    }
    .paralax-cover-image_mobile p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
        padding-bottom: 20Px;
    }

    .paralax-cover-image_mobile .paralax-cover-image-text_mobile,
    .paralax-cover-image_mobile h2 {
        color: #fff;
        font-size: 2em;
        line-height: 1.25;
        z-index: 1;
        margin-bottom: 0;
        max-width: 610px;
        text-align: center;
        margin-left: 8.5%;
    }

    .paralax-cover-image_mobile.has-background-dim_mobile:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image_mobile {
        // background-attachment: fixed;
        background-position: 100% 40px;
    }


    .hero {
        position: relative;
        background-size: cover;
        background-position: center center;
        height: 680px;
        min-height: 320px;
        max-height: 100%;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;
        align-items: center;
        -webkit-justify-content: center;
        -moz-justify-content: center;
        -ms-justify-content: center;
        justify-content: center;
        -ms-flex-pack: center;
        padding: 20px;
    }
    .hero .content_home {
        position: relative;
        min-height: 280px;
        width: 100%;
        margin-left: 8.5%;
        z-index: 2;
        /*//background: red;*/
    }
    .hero .content_home p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
        width: 100%;
        max-width: 100%;
        margin-left: auto;
        margin-right: auto;
    }

    // css du loader
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}


.custom-select-container {
    position: relative;
    width: 100%;
}

.custom-select {
    position: relative;
    width: 100%;
    height: 55px;
    border: 1px solid #d9dee3;
    border-radius: 12px;
    background-color: white;
    cursor: pointer;
    transition: all 0.2s ease;
    min-height: 48px;
    display: flex;
    align-items: center;
}

.custom-select:hover {
    border-color: #d1d5db;
}

.custom-select.active {
    border-color: #ffa409;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.select-input {
    width: 100%;
    padding: 12px 40px 12px 16px;
    border: none;
    outline: none;
    background: transparent;
    font-size: 16px;
    color: #374151;
    cursor: pointer;
}

.select-input::placeholder {
    color: #9ca3af;
    font-size: 15px;
}

.select-arrow {
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    transition: transform 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.select-arrow.rotated {
    transform: translateY(-50%) rotate(180deg);
}

.options-container {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    width: 100%;
    max-height: 280px;
    overflow-y: auto;
    background-color: white;
    border: 0.5px solid #d9dee3;
    border-radius: 12px;
    z-index: 1;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.search-option {
    padding: 12px;
    border-bottom: 1px solid #f3f4f6;
    background-color: #f9fafb;
}

.search-input-in-options {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    outline: none;
    font-size: 14px;
    background-color: white;
    transition: border-color 0.2s ease;
}

.search-input-in-options:focus {
    border-color: #ffa409;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.option {
    padding: 12px 16px;
    cursor: pointer;
    font-size: 15px;
    color: #374151;
    transition: background-color 0.15s ease;
    border-bottom: 0.5px solid #f3f4f6;
}

.option:last-child {
    border-bottom: none;
}

.option:hover {
    background-color: #f3f4f6;
}

.option:active {
    background-color: #e5e7eb;
}

.no-results {
    padding: 16px;
    color: #6b7280;
    font-style: italic;
    text-align: center;
    font-size: 14px;
}

/* Scrollbar personnalisée */
.options-container::-webkit-scrollbar {
    width: 6px;
}

.options-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.options-container::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}

.options-container::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}





.insurers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
}

@media (max-width: 768px) {
  .insurers-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
}

.insurer-card {
  position: relative;
  border-radius: 12px;
  background: #ffffff;
  border: 2px solid #e2e8f0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.insurer-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border-color: #cbd5e0;
}

.insurer-card.selected {
  border-color: #ffa409;
  background: linear-gradient(135deg, #fff7ed 0%, #ffffff 100%);
  box-shadow: 0 4px 20px rgba(255, 164, 9, 0.2);
}

.insurer-card.all-insurers {
  background: linear-gradient(135deg, #ffa409 0%, #ff8c00 100%);
  border-color: #ffa409;
  color: white;
}

.insurer-card.all-insurers.selected {
  background: linear-gradient(135deg, #e69500 0%, #cc7a00 100%);
  transform: scale(1.02);
}

.insurer-input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.insurer-label {
  display: flex;
  align-items: center;
  padding: 1.25rem;
  cursor: pointer;
  width: 100%;
  height: 100%;
  position: relative;
  transition: all 0.3s ease;
}

.insurer-icon {
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7fafc;
  border-radius: 12px;
  margin-right: 1rem;
  transition: all 0.3s ease;
}

.insurer-card.selected .insurer-icon {
  background: rgba(255, 164, 9, 0.1);
}

.insurer-card.all-insurers .insurer-icon {
  background: rgba(255, 255, 255, 0.2);
}

.insurer-logo {
  max-width: 45px;
  max-height: 45px;
  object-fit: contain;
  filter: brightness(1);
  transition: all 0.3s ease;
}

.insurer-card.all-insurers .insurer-logo {
  filter: brightness(0) invert(1);
}

.insurer-info {
  flex: 1;
  min-width: 0;
}

.insurer-name {
  font-size: 1rem;
  font-weight: 500;
  color: #2d3748;
  margin: 0 0 0.25rem 0;
  line-height: 1.2;
  word-break: break-word;
}

.insurer-card.all-insurers .insurer-name {
  color: white;
}

.insurer-badge {
  display: inline-block;
  font-size: 0.85rem;
  font-weight: 500;
  color: #718096;
  background: #edf2f7;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.insurer-card.all-insurers .insurer-badge {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.insurer-card.selected .insurer-badge {
  background: rgba(255, 164, 9, 0.2);
  color: #b45309;
}

.selection-indicator {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  opacity: 0;
  transform: scale(0.8);
}

.insurer-card.selected .selection-indicator {
  opacity: 1;
  transform: scale(1);
  background: #ffa409;
  color: white;
}

.selection-indicator i {
  font-size: 0.75rem;
}

.selection-summary {
  background: linear-gradient(135deg, #e6fffa 0%, #f0fff4 100%);
  border: 1px solid #9ae6b4;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;
}

.summary-content {
  display: flex;
  align-items: center;
  color: #2f855a;
  font-weight: 500;
}

.summary-content i {
  margin-right: 0.5rem;
  font-size: 1.1rem;
}

/* Animation d'entrée */
.insurer-card {
  animation: slideInUp 0.6s ease-out;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Animation pour les cartes sélectionnées */
.insurer-card.selected {
  animation: pulse 0.6s ease-out;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.02);
  }
  100% {
    transform: scale(1);
  }
}

/* Responsive amélioré */
@media (max-width: 480px) {
  .insurer-label {
    padding: 1rem;
  }
  
  .insurer-icon {
    width: 50px;
    height: 50px;
    margin-right: 0.75rem;
  }
  
  .insurer-logo {
    max-width: 35px;
    max-height: 35px;
  }
  
  .insurer-name {
    font-size: 1.4rem;
  }
  
  .modern-title {
    font-size: 1.1rem;
  }
}

/* Amélioration de l'accessibilité */
.insurer-card:focus-within {
  //outline: 2px solid #ffa409;
  outline-offset: 2px;
}

.insurer-input:focus + .insurer-label {
  box-shadow: 0 0 0 3px rgba(255, 164, 9, 0.3);
}

/* États de chargement */
.insurers-grid.loading .insurer-card {
  opacity: 0.6;
  pointer-events: none;
}
</style>
